<form class="form vc-admin-form" (ngSubmit)="execute()">
  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.INDEX_PAGE" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.USERS.LOGIN_PAGE.DESCRIPTION" | translate }}
    </p>

    <div class="vc-admin-form__warning vc-admin-form__warning--info">
      <i class="fas fa-location-dot"></i>
      <p>{{ activeSelectionText }}</p>
    </div>

    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="site">{{ "COMMON.SITE" | translate }}</label>
          <p-select
            inputId="site"
            name="site"
            [options]="sites"
            [(ngModel)]="selectedSite"
            (onChange)="onSelectedSiteChange()"
            [optionLabel]="'name'"
            [dataKey]="'id'"
            appendTo="body"
            fluid
          ></p-select>
          <small class="p-error" *ngIf="errors?.site">{{ errors.site }}</small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="module">{{ "COMMON.MODULE" | translate }}</label>
          <p-select
            inputId="module"
            name="module"
            [options]="modules"
            [(ngModel)]="selectedModule"
            [optionLabel]="'name'"
            [dataKey]="'id'"
            appendTo="body"
            fluid
          ></p-select>
          <small class="p-error" *ngIf="errors?.module">{{ errors.module }}</small>
        </div>
      </div>
    </div>
  </section>

  <app-admin-form-actions
    primaryLabelKey="COMMON.SAVE"
    [submitting]="submitting"
  ></app-admin-form-actions>
</form>
